// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import RentSecurityDepositInput from '../rent-security-deposit';

const RentSecurityDepositInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <RentSecurityDepositInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default RentSecurityDepositInputWithAnalytics;
